import { httpRequest } from "@/lib";

export type ConsentSubjectType = "lead" | "patient";

export interface ContactConsent {
  granted: boolean;
  granted_at: string | null;
  revoked_at: string | null;
  source: string | null;
}

/** VITE_API_URL already includes /api/v1. */
export async function fetchContactConsent(
  subjectType: ConsentSubjectType,
  subjectId: string,
): Promise<ContactConsent> {
  const response = await httpRequest.get<ContactConsent>(`/consents/${subjectType}/${subjectId}`);

  return response.data;
}
